'use client';

import { SubmitButton } from 'app/components/SubmitButton';
import { Message } from 'app/types';
import { Alert, Button, Label, Modal, TextInput } from 'flowbite-react';
import { useState } from 'react';
import { useFormState } from 'react-dom';
import { FaRegTrashAlt } from "react-icons/fa";
import { deleteAnimation } from './ServerActions';

type DeleteAnimationProps = {
    isOwner: boolean,
    jobId: string,
    displayName: string,
}

const initialMessage: Message | undefined = undefined;

export default function DeleteAnimation({ isOwner, jobId, displayName }: DeleteAnimationProps) {
    const [openModal, setOpenModal] = useState(false);
    const [validation, setValidation] = useState("");
    const [msg, formAction] = useFormState(deleteAnimation, initialMessage);

    if (!isOwner) {
        return <></>;
    }

    return <>
        <Modal  className="bg-white dark:bg-custom-dark " dismissible show={openModal} onClose={() => setOpenModal(false)}>
            <form action={formAction}>
                <div className="border border-neutral-400 dark:border-neutral-600 shadow-md dark:shadow-neutral-600">
                    <Modal.Header className='p-2  bg-gray-100 dark:bg-custom-grey'>
                        <div className='flex flex-row items-center gap-2'>
                            <FaRegTrashAlt color='red' className='mr-2 inline' />
                            Delete animation
                        </div>
                    </Modal.Header>
                    {<>
                            <Modal.Body className="bg-gray-100 dark:bg-custom-grey">
                                <div className="space-y-6">
                                    <Label htmlFor="validation"><p className='pb-2'>Deleting an animation is <strong>irreversible</strong>.</p>
                                    <p>Please type <span className='font-mono bg-slate-300 dark:bg-slate-700'>{displayName}</span> below to confirm you really want to do this.</p></Label>
                                    <TextInput
                                        className="w-3/4"
                                        id="validation"
                                        name="reason"
                                        placeholder={`Please enter "${displayName}" to confirm.`}
                                        value={validation}
                                        onChange={(e) => setValidation(e.target.value)}
                                        required />
                                    <TextInput
                                        className="hidden"
                                        readOnly
                                        id="jobid"
                                        name="jobid"
                                        value={jobId} />
                                </div>
                                {msg &&
                                    <div key={msg.timestamp} className='flex flex-row items-center gap-2 px-4 py-2'>
                                        <Alert className='rounded-none'  color={msg.type}>{msg.message}</Alert>
                                    </div>}                            
                            </Modal.Body>
                            <Modal.Footer className="bg-gray-100 dark:bg-custom-grey">
                                <Button
                                    className="rounded-none bg-transparent text-black dark:text-white border-black border-solid dark:border-white px-3 py-1 hover:scale-x-110 hover:ease-linear hover:duration-300 mr-2"  onClick={() => setOpenModal(false)}>
                                        Back
                                </Button>
                                <SubmitButton
                                    className="rounded-none bg-transparent  text-black dark:text-white border-solid border-red-500 dark:border-red-500 px-3 py-1 hover:scale-x-110 hover:ease-linear hover:duration-300"
                                    disabled={validation !== displayName}
                                    color="red"
                                    type="submit">
                                    <FaRegTrashAlt color='red' className='mr-2' />
                                    Delete permanently
                                </SubmitButton>
                                            
                            </Modal.Footer>
                        </>
                    }
                </div>
            </form>
        </Modal>
        <Button color='red' className="items-start rounded-none border-none bg-transparent text-black dark:text-white hover:scale-x-110 hover:ease-linear hover:duration-300" size={'xs'} onClick={() => setOpenModal(true)}>
            <FaRegTrashAlt color='red' className='mr-2' />Delete
        </Button>
    </>
}

